import './EmptyState.scss';

import React from 'react';
import { Button } from '@icarros/torque-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { ReactComponent as ImageEmptyStateMyListings } from '../../assets/images/empty-state-my-listings.svg';
import { ReactComponent as ImageEmptyStateNoOffers } from '../../assets/images/empty-state-no-offers.svg';
import { ReactComponent as ImageEmptyStateSelectOffer } from '../../assets/images/empty-state-select-offer.svg';
import { ReactComponent as RebrandingEmptyFavorites } from '../../assets/rebranding/feedback/empty-spaces/sem-favorito.svg';

export const getEmptyState = type => {
  switch (type) {
    case 'my-listings':
      return {
        title: 'Quer vender seu carro?',
        subTitle: 'Anuncie para mais de 10 milhões de pessoas que acessam o iCarros todos os meses',
        emptyState: <ImageEmptyStateMyListings className="empty-state__image" />,
        buttonText: 'Anunciar',
        buttonLink: '/vender/index.jsp' // TO DO: parametrizar essas informações
      };

    case 'my-favorites':
      return {
        title: 'Está procurando um novo carro?',
        subTitle: 'Salve os seus anúncios favoritos da nossa lista de ofertas',
        emptyState: <RebrandingEmptyFavorites className="empty-state__image" />,
        buttonText: 'Ver Ofertas',
        buttonLink: '/principal/index.jsp'
      };
    case 'offers':
      return {
        title: 'Você ainda não recebeu propostas',
        subTitle:
          'Confira se a descrição do seu anúncio está completa, se o preço está competitivo e se contém boas fotos do carro',
        emptyState: <ImageEmptyStateNoOffers className="empty-state__image" />
      };
    case 'select-offer':
      return {
        title: 'Propostas recebidas',
        subTitle: 'Selecione uma proposta na coluna ao lado',
        emptyState: <ImageEmptyStateSelectOffer className="empty-state__image" />
      };
    default:
      return {};
  }
};

function EmptyState({ className, type }) {
  const { title, subTitle, emptyState, buttonLink, buttonText } = getEmptyState(type);

  const onButtonClick = link => {
    window.open(link, '_blank');
  };

  return (
    <div
      className={classNames('empty-state', {
        [className]: className
      })}
    >
      <span className="empty-state__title">{title}</span>
      <span className="empty-state__subtitle">{subTitle}</span>
      {emptyState}
      {buttonLink && buttonText && (
        <Button
          className="empty-state__button"
          primary
          primaryColor
          onClick={() => onButtonClick(buttonLink)}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
}

EmptyState.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string
};

EmptyState.defaultProps = {
  className: undefined
};

export default EmptyState;
